<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="getData"
            :search="searchModel"
            :expanded.sync="expanded"
            :single-expand="singleExpand"
            show-expand
            item-key="nr"
            show-select
            :page.sync="pageModel"
            :items-per-page="itemsPerPage"
            hide-default-footer
            @page-count="pageCount = $event"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat :color="$store.getters.stdColorLight">
                <v-icon>account_box</v-icon>
                <v-toolbar-title>{{ $t("customer.title") }}</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                >
                </v-divider>
                <v-text-field
                  v-model="searchModel"
                  append-icon="search"
                  :label="$t('message.filter')"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>

                <!-- reporting menu -->
                <v-menu
                  v-model="value"
                  :disabled="menuDisabled"
                  :absolute="absolute"
                  :open-on-hover="openOnHover"
                  :close-on-click="closeOnClick"
                  :close-on-content-click="closeOnContentClick"
                  :offset-x="offsetX"
                  :offset-y="offsetY"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn v-show="selected.length>0" icon v-on="on">
                      <v-icon>receipt</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="showReport('Kundenliste [LIST]',$t('reports.customerListReport'))">
                      <v-list-item-title class="subtitle-2">{{ $t("reports.customerListReport") }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="showReport('KundenBlatt [FORM]',$t('reports.customerFormReport'))">
                      <v-list-item-title class="subtitle-2">{{ $t("reports.customerFormReport") }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <!-- edit/new dialog -->
                <v-dialog v-model="dialog" persistent max-width="800px">
                  <template v-slot:activator="{ on }">
                    <v-btn @click="initItem()" class="white--text" :color="$store.getters.stdColorDark" v-on="on">{{ $t("message.newTitle") }}</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <v-toolbar flat :color="$store.getters.stdColorLight">
                        <v-row justify="center">
                          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                        </v-row>
                      </v-toolbar>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field disabled v-model="editedItem.nr" :label="$t('customer.number')"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="editedItem.code" :label="$t('customer.code')" max="5" counter="5" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.anrede" :label="$t('customer.anrede')" max="15" counter="15" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.nameFirma" :label="$t('customer.name')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.vorname" :label="$t('customer.firstName')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field v-model="editedItem.sachbearbeiter" :label="$t('customer.sachbearbeiter')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.strasse" :label="$t('customer.street')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field v-model="editedItem.strasseNr" max="10" counter="10" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="2">
                            <v-text-field v-model="editedItem.plz" :label="$t('customer.plz')" max="7" counter="7" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.ort" :label="$t('customer.city')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="3">
                            <v-text-field v-model="editedItem.telefonG" :label="$t('customer.telG')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model="editedItem.telefonP" :label="$t('customer.telP')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.mobile" :label="$t('customer.mobile')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="3">
                            <v-text-field v-model="editedItem.telefax" :label="$t('customer.fax')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field v-model="editedItem.mwstNummer" :label="$t('customer.mwstNummer')" max="20" counter="20" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="editedItem.email" :label="$t('customer.email')" max="31" counter="31" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-select
                              v-model="rabattItem"
                              :items="$store.getters.rabattList"
                              :item-text="getRabattText"
                              :item-value="getRabattValue"
                              :label="$t('customer.rabattCode')"
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-textarea class="subtitle-2" v-model="editedItem.bemerkungen" :label="$t('customer.bemerkungen')" rows="2" clearable max="255" counter="255" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-textarea>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn :disabled="checkNavigation('prior')" class="white--text" :color="$store.getters.stdColorDark" text @click="prior()">{{ $t("message.prior") }}</v-btn>
                      <v-btn :disabled="checkNavigation('next')" class="white--text" :color="$store.getters.stdColorDark" text @click="next()">{{ $t("message.next") }}</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="close()">{{ $t("message.cancel") }}</v-btn>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="save(true)">{{ $t("message.save") }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr :bgcolor="customRowClass(item)">
                <td>
                  <v-checkbox v-model="selected" :value="item"></v-checkbox>
                </td>

                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small class="mr-2" v-on="on" @click="editItem(item)">mdi-pencil</v-icon>
                    </template>
                    <span>{{ $t("tooltip.edit") }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on" @click="deleteItem(item)">mdi-delete</v-icon>
                    </template>
                    <span>{{ $t("tooltip.delete") }}</span>
                  </v-tooltip>
                </td>
                <td style="text-align:right">{{item.nr}}</td>
                <td>{{item.vorname}}</td>
                <td>{{item.nameFirma}}</td>
                <td>{{item.strasse}}</td>
                <td>{{item.plz}}</td>
                <td>{{item.ort}}</td>
                <td>{{item.telefonG}}</td>
                <td><v-icon @click="expandRow(item)">{{ getExpandIcon(item) }}</v-icon></td>
              </tr>
            </template>

            <!-- eslint-disable-next-line -->
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <lieferadresse-table v-bind:customer="item" v-show="$store.getters.showLieferadresse && $store.getters.isLoggedOn"></lieferadresse-table>
              </td>
            </template>
          </v-data-table>
          <div>
            <v-pagination v-model="pageModel" :length="pageCount"></v-pagination>
            <v-text-field
              :value="itemsPerPage"
              :label="$t('message.itemsPerPage')"
              type="number"
              min="-1"
              max="100"
              @input="itemsPerPage = parseInt($event, 10)"
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import WebService from "@/plugins/WebService";
import LieferadresseTable from "@/components/LieferadresseTable";
import EntityHelper from "@/plugins/EntityHelper";

export default {
  name: "customer-table",

  components: { LieferadresseTable
  },

  data() {
    return {
      webService: new WebService(this),
      entityHelper: new EntityHelper(this),

      dialog: false,

      rabattItem: this.$store.getters.rabattList.find(o => o.code === 1),
      editedIndex: -1,
      editedItem: {
        mid: '',
        nr: 0,
        anrede: '',
        nameFirma: '',
        vorname: '',
        sachbearbeiter: '',
        strasse: '',
        strasseNr: '',
        plz: '',
        ort: '',
        telefonG: '',
        telefonP: '',
        mobile: '',
        telefax: '',
        bemerkungen: '',
        rabattCode: 1,
        code: '',
        mwstNummer: '',
        email: ''
      },
      defaultItem: {
        mid: '',
        nr: 0,
        anrede: '',
        nameFirma: '',
        vorname: '',
        sachbearbeiter: '',
        strasse: '',
        strasseNr: '',
        plz: '',
        ort: '',
        telefonG: '',
        telefonP: '',
        mobile: '',
        telefax: '',
        bemerkungen: '',
        rabattCode: 1,
        code: '',
        mwstNummer: '',
        email: ''
      },

      //table
      selected: [],
      expanded: [],
      singleExpand: true,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,

      //menu
      menuDisabled: false,
      absolute: false,
      openOnHover: false,
      value: false,
      closeOnClick: true,
      closeOnContentClick: true,
      offsetX: false,
      offsetY: true
    };
  },

  created() {
    this.$store.watch(
      function(state) {
        return state.customerList;
      },
      () => {
        // reset states on data change
        this.expanded = [];
        this.selected = [];
        this.search = '';
      },
      {
        deep: true //add this if u need to watch object properties change etc.
      }
    );
  },

  computed: {
    getData() {
      return this.$store.getters.customerList;
    },

    headers() {
      return [
        {
          text: this.$t("message.actions"),
          value: 'actions',
          sortable: false
        },
        {
          text: this.$t("customer.number"),
          class: "blue-grey--text",
          align: "right",
          sortable: true,
          value: "nr"
        },
        {
          text: this.$t("customer.firstName"),
          class: "blue-grey--text",
          sortable: false,
          value: "vorname"
        },
        {
          text: this.$t("customer.name"),
          class: "blue-grey--text",
          sortable: true,
          value: "nameFirma"
        },
        {
          text: this.$t("customer.street"),
          class: "blue-grey--text",
          sortable: false,
          value: "strasse"
        },
        {
          text: this.$t("customer.plz"),
          class: "blue-grey--text",
          sortable: true,
          value: "plz"
        },
        {
          text: this.$t("customer.city"),
          class: "blue-grey--text",
          sortable: true,
          value: "ort"
        },
        {
          text: this.$t("customer.telG"),
          class: "blue-grey--text",
          sortable: false,
          value: "telefonG"
        },
        { text: "", value: "data-table-expand" }
      ];
    },

    formTitle () {
      return this.editedIndex === -1 ? this.$t("message.newTitle") : this.$t("message.editTitle")
    },

    pageModel: {
      get() {
        return this.page;
      },

      set(value) {
        this.selected = [];
        this.page = value;
      }
    },

    searchModel: {
      get() {
        return this.search;
      },

      set(value) {
        this.selected = [];
        this.search = value;
      }
    }
  },

  methods: {
    expandRow(item) {
      this.expanded = item === this.expanded[0] ? [] : [item];
    },

    getExpandIcon(item)
    {
      return item === this.expanded[0] ? 'mdi-chevron-up' : 'mdi-chevron-down'
    },

    customRowClass(item) {
      if (item==null)
        return ''

      if (this.editedIndex>=0)
      {
        return item.nr === this.editedItem.nr ? this.$store.getters.stdColorSelectedRow : ''
      }
      else
        return ''
    },

    getRabattText: item =>
      item.code.toString() + ":" + item.satz.toString()+"%",

    getRabattValue: item => item,

    initItem()
    {
      this.rabattItem = this.$store.getters.rabattList.find(o => o.code === this.defaultItem.rabattCode);
    },

    editItem(item)
    {
      this.editedIndex = this.$store.getters.customerList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.rabattItem = this.$store.getters.rabattList.find(o => o.code === item.rabattCode);
      this.dialog = true
    },

    deleteItem(item)
    {
      //delete item
      this.$store.dispatch("setConfirmDialog", { showConfirmDialog: true, message: this.$t("message.confirmDelete"), action: "deleteCustomerRecord", params: [item] });
    },

    close()
    {
      this.dialog=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save(closeOnSave)
    {
      this.editedItem.rabattCode=this.rabattItem.code;
      if (this.editedIndex > -1) {
        this.webService.updateItem(this.$store.getters.customersBase, this.editedItem, [this.editedItem.nr])
          .then(response => {
            if (response.request.status==200)
            {
              if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
              {
                //re-read customer data
                this.webService.getItems(this.$store.getters.customersBase)
                  .then(response => {
                    this.$store.dispatch("setCustomerList", response.data);
                  })
                  .catch(err => { console.log(err) });
              }
              else
              {
                this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
              }
            }
          })
          .catch(err => { console.log(err) });
      } else {
        this.webService.insertItem(this.$store.getters.customersBase, this.editedItem)
          .then(response => {
            if (response.request.status==201)
            {
              if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
              {
                //re-read customer data
                this.webService.getItems(this.$store.getters.customersBase)
                  .then(response => {
                    this.$store.dispatch("setCustomerList", response.data);
                  })
                  .catch(err => { console.log(err) });
              }
              else
              {
                this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
              }
            }
          })
          .catch(err => { console.log(err) });
      }      
      if (closeOnSave)
        this.close();
    },

    prior()
    {
      this.save(false)
      this.editedIndex--
      this.editedItem = Object.assign({}, this.$store.getters.customerList[this.editedIndex])
      this.rabattItem = this.$store.getters.rabattList.find(o => o.code === this.editedItem.rabattCode);
    },

    next()
    {
      this.save(false)
      this.editedIndex++
      this.editedItem = Object.assign({}, this.$store.getters.customerList[this.editedIndex])
      this.rabattItem = this.$store.getters.rabattList.find(o => o.code === this.editedItem.rabattCode);
    },

    checkNavigation(mode)
    {
      //new record
      if (this.editedIndex==-1)
        return true
      if (mode=='prior')
      {
        return !(this.editedIndex>0)
      }
      else
      {
        return !(this.editedIndex<(this.$store.getters.customerList.length-1))
      }
    },

    showReport(reportName,reportTitle)
    {
      if (this.selected.length==0)
        return
      
      var birtReportname=reportName.substring(0, reportName.indexOf('[')-1)
      var reportType=reportName.substring(reportName.indexOf('[')+1, reportName.indexOf(']'))
      var values = this.selected.map(item => item.nr);

      this.webService.getItem(this.$store.getters.paramsBase,[this.selected[0].mid])
        .then(response => {
          this.$store.dispatch("setReport", { showReport: true, name: birtReportname, title: reportTitle,
            reportData: {
              name: birtReportname,
              outputType: 'HTML',
              inputType: reportType,
              language: this.$store.getters.selectedLanguage,
              parameters: [
                {
                  title: 'Mandant',
                  name: 'mandantenId',
                  type: 'STRING',
                  value: this.selected[0].mid
                },
                {
                  title: 'Kundennummer',
                  name: 'ku_nr',
                  type: 'INT',
                  value: -1
                }
              ],
              dataSets: [
                {
                  name: 'Data Set',
                  tables: [
                    {
                      schema: 'optimaw',
                      name: 'kunden',
                      primaryKeys: [
                        {
                          name: 'ku_nr',
                          type: 'int'
                        },
                        {
                          name: 'ku_mid',
                          type: 'string'
                        }
                      ]
                    }
                  ],
                  selections: [
                    {
                      schema: 'optimaw',
                      table: 'kunden',
                      field: 'ku_nr',
                      type: 'int',
                      values: values
                    }
                  ]
                }
              ],
              images: [
                {
                  title: 'Logo',
                  name: 'logo',
                  type: response.data.logoType.toUpperCase(),
                  base64Value: response.data.logoBase64Encoded
                }
              ]
            }
          });
        })
        .catch(err => { console.log(err) });
    }

  },

  watch: {
    expanded: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal.length>0)
        {
          // do something when row is expanded, probably re-read some data
          this.entityHelper.setLieferadresseState(true,[newVal[0].nr]);
        }
        else
        {
          this.entityHelper.setLieferadresseState(false,[]);
        }
      }
    },

    dialog (val) {
      val || this.close()
    }
  }

};
</script>

<style scoped>
.large-slider >>> .v-slider {
  height: 60px;
}
</style>
